<div class="admin_footer">
  <div class="admin_footer__copyright">
    <span>Copyright &copy; 2022-{{ currentYear }} </span>
    <a [href]="developerUrl" target="_blank">Content Media</a>
  </div>
  <div class="admin_footer__powered">
    <span>Powered by </span>
    <a [href]="landingUrl" target="_blank">ShareWave</a>
  </div>
</div>
